var modules_3fa78883 = {"container":"_2hv49a","item":"_1cqa7jz"};
import "../../../assets/Do4G87vo.css";

export { modules_3fa78883 as default };
//# sourceMappingURL=Breadcrumb.module.less.js.map
